export default __webpack_public_path__ + "static/media/problema-08.ebe25829.webp";